import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import RouteSizeItem from './RouteSizeItem';
import { getEquipmentSizesAmount, getSizesPercentage } from '../utils';
import { getEquipmentAssignments } from 'react/api/selectors/quickAssignment';

function RouteSizes({ route }) {
  const { plannedSize1, plannedSize2, plannedSize3 } = route || {}

  const equipmentAssignments = useSelector((state) => getEquipmentAssignments(state, route.id));

  const hasEquipmentAssignments = useMemo(() => !!equipmentAssignments?.length, [equipmentAssignments]);

  const sizesSummary = useMemo(() => {
    const { size1, size2, size3 } = getEquipmentSizesAmount(equipmentAssignments);

    return {
      size1: {
        equipmentsAmount: size1,
        hasOverflow: (size1 < plannedSize1) && hasEquipmentAssignments,
        percent: getSizesPercentage(plannedSize1, size1)
      },
      size2: {
        equipmentsAmount: size2,
        hasOverflow: (size2 < plannedSize2) && hasEquipmentAssignments,
        percent: getSizesPercentage(plannedSize2, size2)
      },
      size3: {
        equipmentsAmount: size3,
        hasOverflow: (size3 < plannedSize3) && hasEquipmentAssignments,
        percent: getSizesPercentage(plannedSize3, size3)
      }
    }
  }, [plannedSize1, plannedSize2, plannedSize3, equipmentAssignments, hasEquipmentAssignments]);

  return (
    <div data-testid="route-sizes" className="sizes">
      <RouteSizeItem
        type="size1"
        plannedSize={plannedSize1}
        {...sizesSummary.size1}
      />
      <RouteSizeItem
        type="size2"
        plannedSize={plannedSize2}
        {...sizesSummary.size2}
      />
      <RouteSizeItem
        type="size3"
        plannedSize={plannedSize3}
        {...sizesSummary.size3}
      />
    </div>
  );
}

RouteSizes.propTypes = {
  route: PropTypes.object.isRequired
}

export default RouteSizes;
